import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Input } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import { grey } from '@mui/material/colors';
import PropTypes from 'prop-types';

const UploadBox = ({
  defaultFile,
  onChange = () => {},
  appUrl,
  handleClearIcon,
  placeholder = 'No App Icon',
  isClear = false,
}) => {
  const [image, setImage] = useState(defaultFile);

  useEffect(() => {
    if (defaultFile) {
      setImage(URL.createObjectURL(defaultFile));
      return;
    }

    setImage();
  }, [defaultFile]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
      onChange(file);
    }
  };

  return (
    <>
      {image || appUrl ? (
        <Box
          component={'img'}
          src={image || appUrl}
          sx={{
            width: '100%',
            height: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        />
      ) : (
        <Box
          sx={{
            width: '100%',
            height: 200,
            border: '1px dashed gray',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 2,
            textAlign: 'center',
            backgroundColor: grey[50],
          }}
        >
          <Typography variant='body2' color='textSecondary'>
            {placeholder}
          </Typography>
          <Typography variant='caption' color='textSecondary'>
            Format: PNG
          </Typography>
        </Box>
      )}
      <Box display='flex' justifyContent='center' gap={8} mt={2}>
        <Box>
          <Button
            variant='outlined'
            component='label'
            startIcon={<UploadIcon />}
            sx={{
              mt: 4,
              width: '100%',
              borderColor: '#0000003D',
              color: '#545454',
              maxWidth: 300,
              '&:hover': {
                borderColor: '#545454',
              },
            }}
          >
            Upload
            <Input
              key={image?.name}
              id='image-upload'
              type='file'
              inputProps={{
                accept: '.png',
              }}
              onChange={(e) => {
                const selectedFile = e.target.files[0];

                handleFileChange(e);
                if (selectedFile) {
                  e.target.value = '';
                }
              }}
              sx={{ display: 'none' }}
            />
          </Button>
          {!!image ||
            (isClear && (
              <Button
                variant='outlined'
                component='label'
                color='error'
                sx={{
                  mt: 4,
                  width: '100%',
                  maxWidth: 300,
                }}
                onClick={handleClearIcon}
              >
                Delete
              </Button>
            ))}
        </Box>
      </Box>
    </>
  );
};

export default React.memo(UploadBox);

UploadBox.propTypes = {
  defaultFile: PropTypes.object,
  onChange: PropTypes.func,
  handleClearIcon: PropTypes.func,
  appUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholder: PropTypes.string,
  isClear: PropTypes.bool,
};
